import SettingsPage from 'src/views/abi/SettingsPage'
import pathMap from 'src/paths/pathMap'

class AbiUserSettingsRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ABI_USER_SETTINGS_VIEW,
        component: SettingsPage
      }
    ]
  }
}

export default AbiUserSettingsRoute
